import axios from 'axios'
import { config } from '@/config'

export const api = axios.create({
  baseURL: config.apiUrl,
  // Без cookies: игрок авторизуется Bearer-токеном устройства. С cookies
  // браузер требовал бы Access-Control-Allow-Credentials и конкретный Origin
  // вместо '*' — а в Capacitor-сборке Origin вообще capacitor://localhost.
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
})
